import { render } from "./ProjectIssuesList.vue?vue&type=template&id=8c972730"
import script from "./ProjectIssuesList.vue?vue&type=script&lang=js"
export * from "./ProjectIssuesList.vue?vue&type=script&lang=js"

import "./ProjectIssuesList.vue?vue&type=style&index=0&id=8c972730&lang=scss"
script.render = render

export default script